<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Grouped By Date Sales Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="salesReportProductID" dense outlined v-model="record.ProductId" :items="products"
                label="Products" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="salesTransactionsCustomer" dense outlined v-model="record.CustomerId"
                :items="customers" label="Customer" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="6" xs="6" md="6">
              <!-- <span class="style-18">Total Sales: {{ totalSales  | currency }}</span> -->
            </v-col>

            <v-col cols="6" xs="6" md="6">
              <v-btn class="float-right" :loading="loader" @click="getReport" color="primary"><v-icon
                  left>mdi-list-box-outline</v-icon>Generate Report</v-btn>
            </v-col>
          </v-row>

          <v-row dense v-if="hideTotals != 'Y'">
            <v-col cols="12" xs="12" md="4">
              <download-excel style="cursor: pointer" :data="soldProducts" :fields="fields" name="Grouped Sales Report">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>

            </v-col>
          </v-row>

          <v-row dense class="subtitle-2 text--primary" v-if="hideTotals != 'Y'">
            <v-col cols="12">
              <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
              <!-- start of table -->
              <v-data-table dense :mobile-breakpoint="0" :items-per-page="1000" :headers="headers" :items="soldProducts"
                :search="search">
                <!-- template -->
                <template v-slot:item.Price="{ item }">
                  {{
                    item.Price.toLocaleString()
                  }}
                </template>
                <!-- end -->

                <!-- action template -->
                <template v-slot:item.DocNum="{ item }">
                  <v-btn color="accent" text :to="`/pos/sale-details/${item.InvoiceId}`">{{ item.DocNum }}</v-btn>
                </template>
                <!-- end -->

                <!-- template -->
                <template   v-slot:item.LineTotal="{ item }">
                  {{
                    item.LineTotal | currency
                  }}
                </template>
                <!-- end -->


              </v-data-table>
            </v-col>
          </v-row>



        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      pageItems: 500,
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      products: [],
      customers: [],
      reportData: {},
      outsourcedData: [],
      TotalProfit: null,
      TotalQuantitySold: null,
      brands: [],
      categories: [],
      drivers: [],
      headers: [
        { text: "Shop", value: "Store" },
        { text: "Date", value: "Date" },
        { text: "Product", value: "ProductName" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
      ],
      fields: {
        Store: "Store",
        Date: "Date",
        ProductName: "ProductName",
        Quantity: "Quantity",
        Price: "Price",
      },
      soldProducts: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null
    };
  },
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getProducts() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const url = "/grouped-sales-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.SalesReportData = res.ResponseData;
            self.soldProducts = res.ResponseData.SoldProducts;
            self.totalSales = res.ResponseData.TotalSales;
            self.outsourcedData = res.ResponseData.OutsourcedSales;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() { },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getCustomers(),
      this.getCategories(),
      this.getGenSettings(),
      this.getProducts(),
    ]);
  },
};
</script>

<style lang="scss" scoped></style>